var DetailTabContent = document.querySelectorAll('.en-detail__tab__content');
var DetailTabImage = document.querySelectorAll(' .en-detail__tab__image');
var ProgrammeTabContent = document.querySelectorAll('.programme__tab__content');
var ProgrammeTabImage = document.querySelectorAll(' .programme__tab__image');

function hideImage(ObjImages) {
    for (var j = 0; j < ObjImages.length; j++) {   
        ObjImages[j].style.visibility = 'hidden';
    }
}

function initTabsDetail(ObjImages, ObjContent) {
  
  $('.en-detail__tab__content').first().addClass('active');
  $('.programme__tab__content').first().addClass('active');
  
  for (let i = 0; i < ObjContent.length; i++) {
    
      ObjContent[i].addEventListener('click', function() {
        
          hideImage(ObjImages);
        
          ObjImages[i].style.visibility = 'visible'; 
          $('.en-detail__tab__content.active').removeClass('active');
          $('.programme__tab__content.active').removeClass('active');
          $(this).addClass('active');
        
      });
    
  };
  
};

initTabsDetail(DetailTabImage, DetailTabContent);
initTabsDetail(ProgrammeTabImage, ProgrammeTabContent);


$('#tabheader-2').click( function() {
                                 
	EnDetailmaxHeight = 0;
    
    $('.en-detail__tab').parent().css("display", "block");

    $('#en-detail .en-detail__tab__image').each(function() {

      if ($(this).height() > EnDetailmaxHeight) {

        EnDetailmaxHeight = $(this).height();

      }

    });
  
  $('#en-detail .en-detail__row .en-detail__column:first-child').height(EnDetailmaxHeight); 

});  

$('#programme').click( function() {
                                 
	programmemaxHeight = 0;
    
    $('.programme__tab').parent().css("display", "block");

    $('#en-detail .programme__tab__image').each(function() {

      if ($(this).height() > programmemaxHeight) {

        programmemaxHeight = $(this).height();

      }

    });
  
  $('#en-detail .programme__row .programme__column:first-child').height(programmemaxHeight); 

});